import React from "react";
import { Box, Container, Heading, Text, VStack } from "@chakra-ui/react";

// Shared wrapper so every section shares the same rhythm and heading treatment.
export default function Section({
  id,
  title,
  subtitle,
  bg = "white",
  children,
  ...rest
}) {
  return (
    <Box as="section" id={id} bg={bg} py={{ base: 14, md: 24 }} {...rest}>
      <Container maxW="6xl" px={{ base: 5, md: 8 }}>
        {title && (
          <VStack spacing={3} mb={{ base: 10, md: 14 }} textAlign="center">
            <Box w="40px" h="3px" bg="brand.500" borderRadius="full" />
            <Heading as="h2" fontSize={{ base: "2xl", md: "3xl" }}>
              {title}
            </Heading>
            {subtitle && (
              <Text color="ink.500" maxW="2xl" fontSize={{ base: "md", md: "lg" }}>
                {subtitle}
              </Text>
            )}
          </VStack>
        )}
        {children}
      </Container>
    </Box>
  );
}
